import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Calendar, ChevronRight } from "lucide-react";
import { blogPosts } from "../data/blogPosts";
import useCanonical from "../hooks/useCanonical";

const BlogPage = () => {
  useCanonical("/blog");
  return (
    <>
      <Helmet>
        <title>Blog | Tax Tips & Compliance Guides | WINTRUST SOLUTIONS Coimbatore</title>
        <meta name="description" content="Expert tax tips, GST guides, ITR filing advice, and business compliance articles from WINTRUST SOLUTIONS, your trusted tax consultant in Coimbatore." />
      </Helmet>

      <section className="bg-navy py-12">
        <div className="container-custom">
          <nav className="text-slate-400 text-sm mb-4">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-white">Blog</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-bold text-white font-heading">
            Tax Tips, Guides & Compliance Insights
          </h1>
          <p className="text-slate-300 mt-4 max-w-2xl">
            Stay informed with the latest tax updates, GST compliance guides, and expert tips from WINTRUST SOLUTIONS, Coimbatore's trusted tax consultancy.
          </p>
        </div>
      </section>

      <section className="bg-slate-50 section-padding">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article key={post.slug} className="bg-white rounded-lg border border-slate-100 shadow-sm hover:shadow-md transition-shadow overflow-hidden" data-testid={`blog-card-${post.slug}`}>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs font-semibold text-gold bg-gold/10 px-3 py-1 rounded-full">
                      {post.category}
                    </span>
                    <span className="text-xs text-slate-400 flex items-center gap-1">
                      <Calendar size={12} />
                      {post.date}
                    </span>
                  </div>
                  <h2 className="text-lg font-semibold text-navy mb-3 font-heading leading-snug">
                    <Link to={`/blog/${post.slug}`} className="hover:text-gold transition-colors">
                      {post.title}
                    </Link>
                  </h2>
                  <p className="text-slate-600 text-sm mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="text-gold font-medium text-sm hover:text-gold-dark inline-flex items-center gap-1"
                    data-testid={`read-more-${post.slug}`}
                  >
                    Read More <ChevronRight size={14} />
                  </Link>
                </div>
              </article>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href="https://wintrustsolutions.blogspot.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary inline-flex items-center gap-2"
              data-testid="view-all-articles-btn"
            >
              View All Articles <ChevronRight size={16} />
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogPage;
